import { MediaMatcher } from '@angular/cdk/layout';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { ViewReasonComponent } from 'src/app/admin/components/view-reason/view-reason.component';
import { AppComponent } from 'src/app/app.component';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
declare let $: any;

@Component({
  selector: 'app-result-outcome-page',
  templateUrl: './result-outcome-page.component.html',
  styleUrls: ['./result-outcome-page.component.css'],
})
export class ResultOutcomePageComponent implements OnInit {
  settingsForm: FormGroup;
  private saveApi = environment.url + environment.resultSave;
  private getApi = environment.url + environment.resultGet;
  private saveAll = environment.url + environment.saveAll;
  /**
   * Constructor to initialize the ResultOutcomePageComponent.
   * Sets up the form group with various form controls for different questions.
   * Initializes the media query listener.
   *
   * @param changeDetectorRef - Reference to Angular's change detector for triggering change detection.
   * @param media - Service to match media queries for responsive design.
   * @param router - Angular Router for navigation.
   * @param fb - FormBuilder service for creating reactive forms.
   * @param makeapi - Service for making API calls.
   * @param getdata - Service to retrieve values or data needed by the component.
   * @param notify - Service for displaying notifications.
   * @param dialog - Material dialog service for opening dialogs.
   * @param appCom - Reference to the root AppComponent.
   * @param http - Angular HttpClient for HTTP requests.
   */
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private router: Router,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog,
    private appCom: AppComponent,
    private http: HttpClient
  ) {
    // Initialize the settings form with form controls for each question
    this.settingsForm = this.fb.group({
      // Question 001: Number of Graduated Startups
      numberOfGraduatedIncCentre: [''],
      numberOfGraduatedDocuments: new FormArray([]),
      numberOfGraduatedImagefile: [''],
      numberOfGraduatedNoOfStartup: [''],
      numberOfGraduatedStatus: [''],

      // Question 002: Capacity Utilization
      capacityUtilizationIncCentre: [''],
      capacityUtilizationDocuments: new FormArray([]),
      capacityUtilizationUrlIcWebsite: [''],
      capacityUtilizationImagefile: [''],
      capacityUtilizationPercentage: [''],
      capacityUtilizationStatus: [''],

      // New Question 003: Impact Achieved
      impactAchievedPresent: [''],
      impactAchievedDocuments: new FormArray([]),
      impactAchievedImagefile: [''],
      impactAchievedStatus: [''],

      // New Question 004: Technology Commercialized
      technologyCommercializedPresent: [''],
      technologyCommercializedDocuments: new FormArray([]),
      technologyCommercializedImagefile: [''],
      technologyCommercializedStatus: [''],
      technologyCommercializedNoOfTech: [''],
    });

    // Initialize the mobile query listener to detect changes in the mobile query
    this.mobileQuery = media.matchMedia('(max-width: 992px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
  }
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  ngAfterViewInit(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  get setting() {
    return this.settingsForm.controls;
  }
  /**
   * Lifecycle hook that is called after the component is initialized.
   * It retrieves the data from the API and populates the form.
   * It also calls the getPush method to populate the documentValues array.
   * Finally, it calls the guidelineDatas method to retrieve the guideline data.
   */
  ngOnInit(): void {
    // Call the getPush method to populate the documentValues array
    this.getPush();

    // Call the getDataApi method to retrieve the data from the API and populate the form
    this.getDataApi();

    // Call the guidelineDatas method to retrieve the guideline data
    this.guidelineDatas();
  }
  getValue: any = {};
  /**
   * Fetches the data for the current user from the API and populates the form with the received data.
   * It also calls the showOptions method to show/hide the upload and remove UI options for each question.
   * Finally, it calls the documentValues method to populate the documentValues array.
   */
  getDataApi() {
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('userId'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.getValue = data;
        if (data.responseStatus != 'Failed') {
          this.settingsForm.patchValue(data);

          // Question 001: Number of Graduated Startups
          if (data.numberOfGraduatedIncCentre == 'Yes') {
            this.showOptionsone('Yes', '.upload0', 0, '.set-succ0');
          }

          // Question 002: Capacity Utilization
          if (data.capacityUtilizationIncCentre == 'Yes') {
            this.showOptionstwo('Yes', '.upload1', 1, '.set-succ1');
          }

          // New Question 003: Impact Achieved
          if (data.impactAchievedPresent == 'Yes') {
            this.showOptions10('Yes', '.upload9', 9, '.set-succ9');
          }

          // New Question 004: Technology Commercialized
          if (data.technologyCommercializedPresent == 'Yes') {
            this.showOptions11('Yes', '.upload10', 10, '.set-succ10');
          }

          let getform = this.settingsForm.value;

          // Populate the documentValues array for Question 001
          if (
            data.numberOfGraduatedDocuments != '' &&
            data.numberOfGraduatedDocuments != undefined
          ) {
            this.documentValues[0] = data.numberOfGraduatedDocuments;
            getform.numberOfGraduatedImagefile =
              data.numberOfGraduatedDocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ0').addClass('success');
              $('.upload-wrapper.upload0').addClass('d-none');
              $('.upload-wrapper.upload0').removeClass('success');
              $('.remove-wrapper.upload0').addClass('d-flex');
              $('.remove-wrapper.upload0').addClass('active');
            }, 5000);
          }

          // Populate the documentValues array for Question 002
          if (
            data.capacityUtilizationDocuments != '' &&
            data.capacityUtilizationDocuments != undefined
          ) {
            this.documentValues[1] = data.capacityUtilizationDocuments;
            getform.capacityUtilizationImagefile =
              data.capacityUtilizationDocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ1').addClass('success');
              $('.upload-wrapper.upload1').addClass('d-none');
              $('.upload-wrapper.upload1').removeClass('success');
              $('.remove-wrapper.upload1').addClass('d-flex');
              $('.remove-wrapper.upload1').addClass('active');
            }, 5000);
          }

          // Populate the documentValues array for New Question 003: Impact Achieved
          if (
            data.impactAchievedDocuments != '' &&
            data.impactAchievedDocuments != undefined
          ) {
            this.documentValues[9] = data.impactAchievedDocuments;
            getform.impactAchievedImagefile =
              data.impactAchievedDocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ9').addClass('success');
              $('.upload-wrapper.upload9').addClass('d-none');
              $('.upload-wrapper.upload9').removeClass('success');
              $('.remove-wrapper.upload9').addClass('d-flex');
              $('.remove-wrapper.upload9').addClass('active');
            }, 5000);
          }

          // Populate the documentValues array for New Question 004: Technology Commercialized
          if (
            data.technologyCommercializedDocuments != '' &&
            data.technologyCommercializedDocuments != undefined
          ) {
            this.documentValues[10] = data.technologyCommercializedDocuments;
            getform.technologyCommercializedImagefile =
              data.technologyCommercializedDocuments[0].documentFile;
            setTimeout(function () {
              $('.set-succ10').addClass('success');
              $('.upload-wrapper.upload10').addClass('d-none');
              $('.upload-wrapper.upload10').removeClass('success');
              $('.remove-wrapper.upload10').addClass('d-flex');
              $('.remove-wrapper.upload10').addClass('active');
            }, 5000);
          }

          this.settingsForm.patchValue(getform);
        }
      });
  }

  pickColor(val) {
    return this.getdata.questionStatus(val);
  }
  pickWidth(val) {
    return this.getdata.statusWidth(val);
  }
  innerValue(val) {
    return this.getdata.StatusName(val);
  }
  /**
   * Opens a dialog to display the reason for the given status.
   * @param status - The status object or value to show the reason for.
   */
  viewReasonBtn(status: any): void {
    const dialogRef = this.dialog.open(ViewReasonComponent, {
      width: '390px',
      data: { _status: status },
    });

    // Handle the dialog's closed event
    dialogRef.afterClosed().subscribe((result) => {});
  }
  /**
   * Updates the value of a form control in the settings form.
   * @param event - The event that triggered this function (not used).
   * @param key - The name of the form control to update.
   * @param value - The value to set the form control to.
   */
  setStatus(event: any, key: string, value: any): void {
    this.settingsForm.controls[key].setValue(value);
  }
  /**
   * Populates the `documentValues` array with 12 new document request objects,
   * each containing empty `documentName` and `documentFile` fields.
   */
  getPush() {
    for (let i = 0; i < 12; i++) {
      // Create a new document request object with empty fields
      const req = [
        {
          documentName: '',
          documentFile: '',
        },
      ];
      // Add the object to the array
      this.documentValues.push(req);
    }
  }

  selecetdFile: any = [];
  url: any;
  ImageValue: any = '';
  ImageType: any;
  documentValues = [];
  /**
   * Handles file upload events, processes the selected file, and updates form controls and UI states.
   * Accepts only jpeg, jpg, png, and pdf files.
   *
   * @param event - The file input change event.
   * @param val - A value used for UI selector construction.
   * @param i - Index indicating which document/form control to update.
   * @param set - Selector or reference for additional UI updates.
   */
  fileUpload(event, val, i, set) {
    // Select the first file from the file input
    this.selecetdFile = event.target.files[0];

    if (event.target.files && this.selecetdFile) {
      let reader = new FileReader();
      let imagetype = this.selecetdFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];

      // Check if the file type is one of the allowed types
      if (['jpeg', 'jpg', 'png', 'pdf'].includes(img_crt_type)) {
        reader.readAsDataURL(this.selecetdFile);

        reader.onload = () => {
          // Process the uploaded file and update the document values
          this.url = reader.result;
          let spl = this.url.split(',');
          let val = this.documentValues[i];
          val[0].documentFile = spl[1];
          val[0].documentName = this.selecetdFile.name;
          this.documentValues[i] = val;

          // Update form controls based on the index
          if (i == 0) {
            this.settingsForm.controls['numberOfGraduatedStatus'].setValue(7);
            this.settingsForm.controls['numberOfGraduatedImagefile'].setValue(
              this.selecetdFile.name
            );
          }
          if (i == 1) {
            this.settingsForm.controls['capacityUtilizationStatus'].setValue(7);
            this.settingsForm.controls['capacityUtilizationImagefile'].setValue(
              this.selecetdFile.name
            );
          }
          if (i == 9) {
            this.settingsForm.controls['impactAchievedStatus'].setValue(7);
            this.settingsForm.controls['impactAchievedImagefile'].setValue(
              this.selecetdFile.name
            );
          }
          if (i == 10) {
            this.settingsForm.controls[
              'technologyCommercializedStatus'
            ].setValue(7);
            this.settingsForm.controls[
              'technologyCommercializedImagefile'
            ].setValue(this.selecetdFile.name);
          }
        };

        // Update UI states with timed animations
        setTimeout(() => {
          let datass = '.upload-wrapper' + val;
          $(datass).addClass('uploaded');
        }, 600);

        setTimeout(() => {
          let datas = '.upload-wrapper' + val;
          $(datas).removeClass('uploaded').addClass('success');
          $(set).addClass('success');
        }, 1600);

        setTimeout(() => {
          let datas = '.upload-wrapper' + val;
          $(datas).addClass('d-none').removeClass('success');
          let data = '.remove-wrapper' + val;
          $(data).addClass('d-flex active');
        }, 5000);
      } else {
        // Notify the user if the file type is not allowed
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png formet images are allowed'
        );
      }
    }
  }
  /**
   * Removes the file from the document values array and updates the settings form.
   * @param val - A value used for UI selector construction.
   * @param i - Index indicating which document/form control to update.
   * @param set - Selector or reference for additional UI updates.
   */
  removeFile(val, i, set) {
    // Remove the file from the document values array
    this.documentValues[i][0].documentFile = '';
    this.documentValues[i][0].documentName = '';

    // Update the UI states with timed animations
    setTimeout(function () {
      let datass = '.upload-wrapper' + val;
      $(datass).removeClass('d-none');
      let data = '.remove-wrapper' + val;
      $(data).removeClass('d-flex');
      $(data).removeClass('active');
      $(set).removeClass('success');
    }, 1000);

    // Update the form controls based on the index
    if (i == 0) {
      // Update the numberOfGraduated form control
      this.settingsForm.controls['numberOfGraduatedStatus'].setValue(1);
      this.settingsForm.controls['numberOfGraduatedImagefile'].setValue('');
    }
    if (i == 1) {
      // Update the capacityUtilization form control
      this.settingsForm.controls['capacityUtilizationStatus'].setValue(1);
      this.settingsForm.controls['capacityUtilizationImagefile'].setValue('');
    }
    // new 3rs qus
    if (i == 9) {
      // Update the impactAchieved form control
      this.settingsForm.controls['impactAchievedStatus'].setValue(1);
      this.settingsForm.controls['impactAchievedImagefile'].setValue('');
    }
    // new 4rs qus
    if (i == 10) {
      // Update the technologyCommercialized form control
      this.settingsForm.controls['technologyCommercializedStatus'].setValue(1);
      this.settingsForm.controls['technologyCommercializedImagefile'].setValue(
        ''
      );
    }
  }
  Optionsonechecked = '';
  /**
   * Handles the change event for the number of graduated options.
   * Updates the form controls and their validators based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference used for additional UI updates.
   */
  showOptionsone(event, val, i, set) {
    // Set the checked option based on the event value
    this.Optionsonechecked = event;

    if (event == 'No') {
      // If "No" is selected, remove the file and clear related form controls and validators
      this.removeFile(val, i, set);
      this.settingsForm.controls['numberOfGraduatedNoOfStartup'].setValue(0);
      this.settingsForm.controls[
        'numberOfGraduatedNoOfStartup'
      ].clearValidators();
      this.settingsForm.controls['numberOfGraduatedImagefile'].setValue('');
      this.settingsForm.controls[
        'numberOfGraduatedImagefile'
      ].clearValidators();
    } else {
      // If "Yes" is selected, set required validators for form controls
      this.settingsForm.controls['numberOfGraduatedImagefile'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['numberOfGraduatedNoOfStartup'].setValidators([
        Validators.required,
      ]);
    }

    // Update validity of form controls
    this.settingsForm.controls[
      'numberOfGraduatedImagefile'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'numberOfGraduatedNoOfStartup'
    ].updateValueAndValidity();
  }
  Optionstwochecked = '';
  /**
   * Handles the change event for the capacity utilization options.
   * Updates the form controls and their validators based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference used for additional UI updates.
   */
  showOptionstwo(event, val, i, set) {
    this.Optionstwochecked = event;
    if (event == 'No') {
      // If 'No' is selected, remove the file and clear validators.
      this.removeFile(val, i, set);
      // Clear the capacity utilization percentage value and validators.
      this.settingsForm.controls['capacityUtilizationPercentage'].setValue(0);
      this.settingsForm.controls[
        'capacityUtilizationPercentage'
      ].clearValidators();
      // Clear the capacity utilization URL value and validators.
      this.settingsForm.controls['capacityUtilizationUrlIcWebsite'].setValue(
        ''
      );
      this.settingsForm.controls[
        'capacityUtilizationUrlIcWebsite'
      ].clearValidators();
      // Clear the capacity utilization image file value and validators.
      this.settingsForm.controls['capacityUtilizationImagefile'].setValue('');
      this.settingsForm.controls[
        'capacityUtilizationImagefile'
      ].clearValidators();
    } else {
      // If 'Yes' is selected, set required validators.
      this.settingsForm.controls[
        'capacityUtilizationUrlIcWebsite'
      ].setValidators([Validators.required, RxwebValidators.url()]);
      this.settingsForm.controls['capacityUtilizationImagefile'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['capacityUtilizationPercentage'].setValidators(
        [Validators.required]
      );
    }
    // Update the validity of the form controls.
    this.settingsForm.controls[
      'capacityUtilizationUrlIcWebsite'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'capacityUtilizationImagefile'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'capacityUtilizationPercentage'
    ].updateValueAndValidity();
  }
  // new 3rd qus
  Options10checked = '';
  /**
   * Handles the change event for impact achieved options.
   * Updates the form controls and their validators based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference used for additional UI updates.
   */
  showOptions10(event, val, i, set) {
    // Store the selected option in Options10checked
    this.Options10checked = event;

    if (event == 'No') {
      // If 'No' is selected, remove the file and clear validators
      this.removeFile(val, i, set);
      this.settingsForm.controls['impactAchievedImagefile'].setValue('');
      this.settingsForm.controls['impactAchievedImagefile'].clearValidators();
    } else {
      // If 'Yes' is selected, set the required validator
      this.settingsForm.controls['impactAchievedImagefile'].setValidators([
        Validators.required,
      ]);
    }
    // Update the validity of the impactAchievedImagefile control
    this.settingsForm.controls[
      'impactAchievedImagefile'
    ].updateValueAndValidity();
  }
  // new 4rd qus
  Options11checked = '';
  /**
   * Handles the change event for technology commercialization options.
   * Updates the form controls and their validators based on the selected option.
   *
   * @param event - The selected value of the radio button ('Yes' or 'No').
   * @param val - A value used for identifying the file input or related UI element.
   * @param i - The index used for updating the document values.
   * @param set - A selector or reference used for additional UI updates.
   */
  showOptions11(event, val, i, set) {
    // Store the selected option in a class variable
    this.Options11checked = event;

    // If 'No' is selected, remove the file and clear the associated validators
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['technologyCommercializedNoOfTech'].setValue(
        0
      );
      this.settingsForm.controls[
        'technologyCommercializedNoOfTech'
      ].clearValidators();
      this.settingsForm.controls['technologyCommercializedImagefile'].setValue(
        ''
      );
      this.settingsForm.controls[
        'technologyCommercializedImagefile'
      ].clearValidators();
    } else {
      // If 'Yes' is selected, set the required validators
      this.settingsForm.controls[
        'technologyCommercializedImagefile'
      ].setValidators([Validators.required]);
      this.settingsForm.controls[
        'technologyCommercializedNoOfTech'
      ].setValidators([Validators.required]);
    }

    // Update the validity of the form controls
    this.settingsForm.controls[
      'technologyCommercializedImagefile'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'technologyCommercializedNoOfTech'
    ].updateValueAndValidity();
  }

  /**
   * Saves the form data
   * If the form is invalid, shows an error notification.
   * If the form is valid, attaches document values if available, and submits the data to the API.
   * Shows notifications based on the result.
   */
  saveBtn() {
    let getform = this.settingsForm.value;

    if (this.settingsForm.invalid) {
      // Mark all form fields as touched and show an error notification if the form is invalid
      this.settingsForm.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      // Attach documents to the form data if available
      if (this.documentValues[0][0].documentFile != '') {
        getform.numberOfGraduatedDocuments = this.documentValues[0];
      }
      if (this.documentValues[1][0].documentFile != '') {
        getform.capacityUtilizationDocuments = this.documentValues[1];
      }
      // new 3rd qus
      if (this.documentValues[9][0].documentFile != '') {
        getform.impactAchievedDocuments = this.documentValues[9];
      }
      // new 4rd qus
      if (this.documentValues[10][0].documentFile != '') {
        getform.technologyCommercializedDocuments = this.documentValues[10];
      }
      this.getdata.amizhthLoader('show');
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          // Increment the step value if the API call is successful
          this.step++;
          this.notify.notifysuccess(data.responseMessage);
          // Call the getDataApi method to fetch the data again
          this.getDataApi();
        } else {
          this.notify.notifyError(data.responseMessage);
        }
      });
    }
  }
  /**
   * Calls the API to save all the data for the current user.
   * Shows a loading indicator while the request is in progress.
   * If the API call is successful, shows a success notification and navigates to the dashboard.
   * If the API call fails, shows an error notification.
   */
  SaveAllApi() {
    // Show a loading indicator
    this.getdata.amizhthLoader('show');

    // Call the API to save all the data
    this.makeapi.method(this.saveAll, '', 'get').subscribe((data) => {
      // Hide the loading indicator
      this.getdata.amizhthLoader('hide');

      // If the API call is successful, show a success notification and navigate to the dashboard
      if (data.responseStatus == 'Success') {
        this.notify.notifysuccess(data.responseMessage);
        this.router.navigate([
          'admin',
          'dashboard',
          sessionStorage.getItem('username'),
        ]);
      }
      // If the API call fails, show an error notification
      else {
        this.notify.notifyError(data.responseMessage);
      }
    });
  }
  guidelinesBtn(data) {
    this.appCom.guidelinesModal(data);
  }
  guidelineValue: any = [];
  guidelineDatas() {
    this.http.get('/assets/json/guideline.json').subscribe((data) => {
      this.guidelineValue = data[7].questions;
    });
  }
  step = 0;
  setStep(index: number) {
    this.step = index;
  }
  nextStep() {
    this.saveBtn();
  }
  prevStep() {
    this.step--;
  }
}
